import { gsap } from "gsap";

// MVのロゴ・コピー3行・マーケエリアの初回表示アニメーション。
// 汎用のscrollIn（ScrollTrigger、"top 80%"等のビューポート基準）だと、
// vh（ビューポート高さ）が低い端末でMV全体がその基準に収まりきらず、
// 要素ごとに発火タイミングがズレて意図した時差にならないため、
// ロード完了（init）からの経過時間だけで動く専用タイムラインにしている。
export const mvContentReveal = (): void => {
  const logo = document.querySelector<HTMLElement>(".p-top-mv-content__logo");
  const lines = document.querySelectorAll<HTMLElement>(".p-top-mv-content__line");
  const marqueeImgs = document.querySelector<HTMLElement>(".p-top-mv-marquee__imgs");

  if (logo) {
    gsap.set(logo, { opacity: 0, y: "10%" });
    gsap.to(logo, {
      opacity: 1,
      y: 0,
      duration: 1,
      delay: 1.5,
    });
  }

  // clip-pathのinset()は% と px が混在するとGSAPの補間がうまくいかず0%に寄ってしまうため、
  // 開始値も要素の実際の高さからpx換算し、両端の単位をpxに揃えてfromToで指定する。
  lines.forEach((line, index) => {
    const restingClipPath = getComputedStyle(line).clipPath;
    gsap.fromTo(
      line,
      { clipPath: `inset(0px 0px ${line.offsetHeight}px 0px)` },
      {
        clipPath: restingClipPath,
        duration: 1.4,
        delay: 1.5 + index * 0.2,
        ease: "power3.out",
      }
    );
  });

  if (marqueeImgs) {
    gsap.set(marqueeImgs, { opacity: 0 });
    gsap.to(marqueeImgs, {
      opacity: 1,
      duration: 1,
      delay: 2,
    });
  }
};
